import _get from 'lodash/get';
import _isEmpty from 'lodash/isEmpty';
import hasDom from 'has-dom';
import { v5 } from 'uuid';
function buildVehicleObject(listedPrice) {
  let listing = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  const primary = _get(listing, ['images', 'primary'], 0);
  const image = listing?.urls?.imageUrl ?? _get(listing, `images.sources[${primary}]`, {});
  const miles = listing.specifications ? _get(listing, 'specifications.mileage.value', '0').replace(/\D/g, '') : listing.mileage;
  const interiorColor = _get(listing, 'specifications.interiorColor.value');
  const exteriorColor = _get(listing, 'specifications.color.value');
  // Required value for leads per DR despite documented as optional
  // for DDC, we can ask them to add the vdpUrl and imageUrl to the payload
  const vdpUrl = listing?.urls?.vdpUrl ?? hasDom() ? document.URL : '';
  // account for different listing object structures
  const listingType = listing.type || listing.listingType || listing.condition || '';
  const {
    stockNumber = ''
  } = listing;

  /**
   * These are the required attributes
   */
  const vehicleInfo = {
    condition: listingType.toLowerCase(),
    listedPrice,
    mileage: Number(miles),
    retailPrice: listing.pricingDetail?.msrp || listedPrice,
    // cannot be 0
    year: listing.year,
    vin: listing?.vin || '',
    uuid: listing?.id?.toString() ?? listing?.vin ?? v5.uuid
  };

  /**
   * These values are optional and should not be included if string or value is empty
   * (empty strings cause the overlay to throw errors and fail to open)
   */
  if (listing.styleId > 0) {
    vehicleInfo.chromeStyleId = listing.styleId.toString();
  }
  const make = listing?.make?.name ?? listing?.make;
  const model = listing?.model?.name ?? listing?.model;
  const trim = listing?.trim?.name ?? listing?.trim;
  if (make && make.length > 0) vehicleInfo.make = make;
  if (model && model.length > 0) vehicleInfo.model = model;
  if (trim && trim.length > 0) vehicleInfo.trim = trim;
  if (stockNumber.length > 0 && stockNumber !== 'Information Unavailable') {
    vehicleInfo.stock = stockNumber;
  }
  if (interiorColor) {
    vehicleInfo.interiorColor = interiorColor;
  }
  if (exteriorColor) {
    vehicleInfo.exteriorColor = exteriorColor;
  }
  const urls = {};
  if (vdpUrl) {
    urls.vdpUrl = vdpUrl;
  }
  if (image.src) {
    urls.imageUrl = image.src;
  }
  if (!_isEmpty(urls)) {
    vehicleInfo.urls = urls;
  }
  return vehicleInfo;
}
export { buildVehicleObject as default };
